import { useEffect, useState, useMemo } from "react";
import axios from "../api/axios";
import { Link } from "react-router-dom";
import "../styles/theme-dark.css";

const API_BASE =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://panel.corex3.com";


function glassStyle(extra = {}) {
  return {
    background: "rgba(15,23,42,0.78)",
    borderRadius: 14,
    border: "1px solid rgba(148,163,184,0.45)",
    backdropFilter: "blur(12px)",
    boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
    ...extra,
  };
}

const safeDate = (d) => {
  if (!d) return "-";
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return "-";
  return dt.toLocaleDateString("es-ES");
};

export default function Documentos() {
  const [tab, setTab] = useState("envio");

  const [docsEnvio, setDocsEnvio] = useState([]);
  const [docsInstal, setDocsInstal] = useState([]);

  const [presupuestos, setPresupuestos] = useState([]);
  const [checklistItems, setChecklistItems] = useState([]);
  const [clientes, setClientes] = useState([]);

  const [loading, setLoading] = useState(true);

  const [showEnvioModal, setShowEnvioModal] = useState(false);
  const [envioForm, setEnvioForm] = useState({
    presupuestoId: "",
    fecha: "",
  });

  const [showInstalModal, setShowInstalModal] = useState(false);
  const [instalForm, setInstalForm] = useState({
    presupuestoId: "",
    fecha: "",
    checklistSeleccionada: [],
  });

  const [showChecklistModal, setShowChecklistModal] = useState(false);
  const [nuevoItemTexto, setNuevoItemTexto] = useState("");

  const [balanceClienteId, setBalanceClienteId] = useState("");
  const [balanceInfo, setBalanceInfo] = useState(null);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [balanceError, setBalanceError] = useState("");

  console.log("AXIOS BASEURL →", axios.defaults.baseURL);

  useEffect(() => {
    cargarTodo();
  }, []);

  const cargarTodo = async () => {
    try {
      setLoading(true);

      const [enviosR, instalR, presupR, checklistR, clientesR] =
  await Promise.all([
    axios.get("/documentos/envio"),                   // ✔ OK - LISTADO DE ENVÍOS
    axios.get("/documentos/instalacion"),             // ✔ Cambiado
    axios.get("/presupuestos"),                       // ✔ OK
    axios.get("/documentos/instalacion/checklist"),   // ✔ Cambiado
    axios.get("/clientes"),                           // ✔ OK
  ]);


      setDocsEnvio(enviosR.data || []);
      setDocsInstal(instalR.data || []);

      // obtener presupuestos aceptados y facturados desde el backend ya limpios
const presup = await axios.get("/presupuestos");
setPresupuestos(presup.data?.data || []);



      setChecklistItems(checklistR.data || []);

      const cliData = Array.isArray(clientesR.data)
        ? clientesR.data
        : clientesR.data?.data || [];
      setClientes(cliData);
    } catch (err) {
      console.error("Error cargando documentos:", err);
    } finally {
      setLoading(false);
    }
  };

  const openEnvioModal = () => {
    const hoyStr = new Date().toISOString().split("T")[0];
    setEnvioForm({ presupuestoId: "", fecha: hoyStr });
    setShowEnvioModal(true);
  };

  const crearDocumentoEnvio = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/documentos/envio", envioForm);
      const doc = res.data;

      setDocsEnvio((prev) => [doc, ...prev]);
      setShowEnvioModal(false);
    } catch (err) {
      console.error("Error creando documento de envío:", err);
      alert("No se pudo crear el informe de envío");
    }
  };

  const openInstalModal = () => {
    const hoyStr = new Date().toISOString().split("T")[0];
    setInstalForm({
      presupuestoId: "",
      fecha: hoyStr,
      checklistSeleccionada: [],
    });
    setShowInstalModal(true);
  };

  const toggleChecklistItemSeleccionado = (id) => {
    setInstalForm((prev) => {
      const seleccionado = new Set(prev.checklistSeleccionada);
      if (seleccionado.has(id)) seleccionado.delete(id);
      else seleccionado.add(id);
      return {
        ...prev,
        checklistSeleccionada: Array.from(seleccionado),
      };
    });
  };

  const crearDocumentoInstalacion = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...instalForm };
      const res = await axios.post("/informes/instalacion", payload);
      const doc = res.data;

      setDocsInstal((prev) => [doc, ...prev]);
      setShowInstalModal(false);
    } catch (err) {
      console.error("Error creando documento de instalación:", err);
      alert("No se pudo crear el documento de instalación");
    }
  };

  const openChecklistModal = () => {
    setNuevoItemTexto("");
    setShowChecklistModal(true);
  };

  const crearChecklistItem = async (e) => {
    e.preventDefault();
    if (!nuevoItemTexto.trim()) return;

    try {
      const res = await axios.post("/informes/instalacion/checklist", {
        texto: nuevoItemTexto.trim(),
      });
      const item = res.data;
      setChecklistItems((prev) => [...prev, item]);
      setNuevoItemTexto("");
    } catch (err) {
      console.error("Error creando checklist:", err);
      alert("No se pudo crear el item");
    }
  };

  const toggleChecklistActivo = async (item) => {
    try {
      const res = await axios.put(
        `/informes/instalacion/checklist/${item.id}`,
        { activo: !item.activo }
      );
      const updated = res.data;
      setChecklistItems((prev) =>
        prev.map((x) => (x.id === updated.id ? updated : x))
      );
    } catch (err) {
      console.error("Error actualizando checklist:", err);
      alert("No se pudo actualizar el item");
    }
  };

  const cargarBalance = async () => {
    if (!balanceClienteId) return;

    setBalanceLoading(true);
    setBalanceError("");
    setBalanceInfo(null);

    try {
      const res = await axios.get(`/informes/balance/${balanceClienteId}`);
      setBalanceInfo(res.data);
    } catch (err) {
      console.error("Error balance:", err);
      setBalanceError("No se pudo cargar el balance");
    } finally {
      setBalanceLoading(false);
    }
  };

  const generarPdfBalance = async () => {
    if (!balanceInfo || !balanceClienteId) return;

    try {
      const res = await axios.post("/informes/balance/pdf", {
        cliente: balanceInfo.cliente,
        facturas: balanceInfo.facturas,
        totales: balanceInfo.totales,
        fecha: new Date().toISOString().split("T")[0],
      });

      if (res.data.pdfUrl) {
        window.open(`${API_BASE}${res.data.pdfUrl}`, "_blank");
      }
    } catch (err) {
      alert("No se pudo generar el PDF");
    }
  };

  const getPresupuestoLabel = (p) =>
  `${p.numero} | ${p.clienteNombre}`;

  const docsEnvioOrdenados = useMemo(
    () => [...docsEnvio].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)),
    [docsEnvio]
  );

  const docsInstalOrdenados = useMemo(
    () => [...docsInstal].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)),
    [docsInstal]
  );

  if (loading) return <div style={{ padding: 20 }}>Cargando informes…</div>;

  return (
    <div className="page-dark" style={{ padding: 16 }}>
      <header
        style={{
          padding: "18px 22px",
          marginBottom: 18,
          background: "rgba(15,23,42,0.65)",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(10px)",
          borderRadius: "0 0 16px 16px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
        }}
      >
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
            Informe
          </h1>
          <p style={{ opacity: 0.7, marginTop: 4, fontSize: 13 }}>
            Informes de envío, instalación y balance generados a partir de tus
            datos.
          </p>
        </div>

        <Link to="/" className="glass-btn" style={{ fontSize: 13 }}>
          ← Volver al panel
        </Link>
      </header>

      {/* TABS */}
      <div
        style={{
          ...glassStyle({ padding: 6, marginBottom: 16 }),
          display: "flex",
          gap: 6,
        }}
      >
        <button
          onClick={() => setTab("envio")}
          style={{
            flex: 1,
            padding: "8px 10px",
            borderRadius: 10,
            border: "none",
            cursor: "pointer",
            fontSize: 13,
            fontWeight: 600,
            background:
              tab === "envio" ? "rgba(59,130,246,0.35)" : "transparent",
            color: "white",
          }}
        >
          📦 Informe de envío
        </button>

        <button
          onClick={() => setTab("instalacion")}
          style={{
            flex: 1,
            padding: "8px 10px",
            borderRadius: 10,
            border: "none",
            cursor: "pointer",
            fontSize: 13,
            fontWeight: 600,
            background:
              tab === "instalacion" ? "rgba(34,197,94,0.35)" : "transparent",
            color: "white",
          }}
        >
          🛠 Informe de instalación
        </button>

        <button
          onClick={() => setTab("balance")}
          style={{
            flex: 1,
            padding: "8px 10px",
            borderRadius: 10,
            border: "none",
            cursor: "pointer",
            fontSize: 13,
            fontWeight: 600,
            background:
              tab === "balance" ? "rgba(234,179,8,0.35)" : "transparent",
            color: "white",
          }}
        >
          📊 Balance de facturas
        </button>
      </div>

      {tab === "envio" ? (
        <SeccionEnvio docs={docsEnvioOrdenados} onNuevo={openEnvioModal} />
      ) : tab === "instalacion" ? (
        <SeccionInstalacion
          docs={docsInstalOrdenados}
          onNuevo={openInstalModal}
          onGestionChecklist={openChecklistModal}
        />
      ) : (
        <SeccionBalance
          clientes={clientes}
          balanceClienteId={balanceClienteId}
          setBalanceClienteId={setBalanceClienteId}
          balanceInfo={balanceInfo}
          balanceLoading={balanceLoading}
          balanceError={balanceError}
          onBuscarBalance={cargarBalance}
          onGenerarPdf={generarPdfBalance}
        />
      )}

      {/* MODAL ENVÍO */}
      {showEnvioModal && (
        <Modal
          onClose={() => setShowEnvioModal(false)}
          title="Nuevo informe de envío"
        >
          <form onSubmit={crearDocumentoEnvio} className="modal-body">
            <div style={{ marginBottom: 10 }}>
              <label>Presupuesto aceptado *</label>
              <select
                required
                value={envioForm.presupuestoId}
                onChange={(e) =>
                  setEnvioForm((prev) => ({
                    ...prev,
                    presupuestoId: e.target.value,
                  }))
                }
                className="glass-input"
              >
                <option value="">Selecciona un presupuesto…</option>
                {presupuestos.map((p) => (
                  <option key={p.id} value={p.id}>
                    {getPresupuestoLabel(p)}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: 10 }}>
              <label>Fecha del documento</label>
              <input
                type="date"
                className="glass-input"
                value={envioForm.fecha}
                onChange={(e) =>
                  setEnvioForm((prev) => ({ ...prev, fecha: e.target.value }))
                }
              />
            </div>

            <div style={{ textAlign: "right", marginTop: 16 }}>
              <button
                type="button"
                className="btn-small"
                onClick={() => setShowEnvioModal(false)}
                style={{ marginRight: 8 }}
              >
                Cancelar
              </button>
              <button type="submit" className="btn-small">
                Generar PDF
              </button>
            </div>
          </form>
        </Modal>
      )}

      {/* MODAL INSTALACIÓN */}
      {showInstalModal && (
        <Modal
          onClose={() => setShowInstalModal(false)}
          title="Nuevo informe de instalación"
        >
          <form onSubmit={crearDocumentoInstalacion} className="modal-body">
            <div style={{ marginBottom: 10 }}>
              <label>Presupuesto aceptado *</label>
              <select
                required
                value={instalForm.presupuestoId}
                onChange={(e) =>
                  setInstalForm((prev) => ({
                    ...prev,
                    presupuestoId: e.target.value,
                  }))
                }
                className="glass-input"
              >
                <option value="">Selecciona un presupuesto…</option>
                {presupuestos.map((p) => (
                  <option key={p.id} value={p.id}>
                    {getPresupuestoLabel(p)}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: 10 }}>
              <label>Fecha del documento</label>
              <input
                type="date"
                className="glass-input"
                value={instalForm.fecha}
                onChange={(e) =>
                  setInstalForm((prev) => ({
                    ...prev,
                    fecha: e.target.value,
                  }))
                }
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <label>Checklist de instalación</label>
              <div
                style={{
                  maxHeight: 200,
                  overflow: "auto",
                  padding: 8,
                  borderRadius: 10,
                  border: "1px solid rgba(148,163,184,0.4)",
                }}
              >
                {checklistItems
                  .filter((i) => i.activo)
                  .map((item) => (
                    <label
                      key={item.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        fontSize: 13,
                        marginBottom: 4,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={instalForm.checklistSeleccionada.includes(
                          item.id
                        )}
                        onChange={() =>
                          toggleChecklistItemSeleccionado(item.id)
                        }
                      />
                      <span>{item.texto}</span>
                    </label>
                  ))}
              </div>
            </div>

            <div style={{ textAlign: "right", marginTop: 16 }}>
              <button
                type="button"
                className="btn-small"
                onClick={() => setShowInstalModal(false)}
                style={{ marginRight: 8 }}
              >
                Cancelar
              </button>
              <button type="submit" className="btn-small">
                Generar PDF
              </button>
            </div>
          </form>
        </Modal>
      )}

      {/* MODAL CHECKLIST */}
      {showChecklistModal && (
        <Modal
          onClose={() => setShowChecklistModal(false)}
          title="Gestionar checklist"
        >
          <form onSubmit={crearChecklistItem} className="modal-body">
            <div style={{ marginBottom: 10 }}>
              <label>Nuevo item</label>
              <input
                className="glass-input"
                value={nuevoItemTexto}
                onChange={(e) => setNuevoItemTexto(e.target.value)}
                placeholder="Ej: Máquina nivelada"
              />
            </div>

            <div style={{ textAlign: "right", marginBottom: 12 }}>
              <button type="submit" className="btn-small">
                Añadir item
              </button>
            </div>
          </form>

          <div
            style={{
              maxHeight: 220,
              overflow: "auto",
              borderRadius: 10,
              border: "1px solid rgba(148,163,184,0.4)",
              padding: 8,
              marginBottom: 10,
            }}
          >
            {checklistItems.map((item) => (
              <div
                key={item.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 13,
                  marginBottom: 4,
                }}
              >
                <span
                  style={{
                    opacity: item.activo ? 1 : 0.5,
                    textDecoration: item.activo ? "none" : "line-through",
                  }}
                >
                  {item.texto}
                </span>
                <button
                  className="btn-small"
                  onClick={() => toggleChecklistActivo(item)}
                >
                  {item.activo ? "Desactivar" : "Activar"}
                </button>
              </div>
            ))}
          </div>

          <div style={{ textAlign: "right" }}>
            <button
              className="btn-small"
              onClick={() => setShowChecklistModal(false)}
            >
              Cerrar
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}

/* ==========================
   SUBCOMPONENTES
========================== */

function SeccionEnvio({ docs, onNuevo }) {
  return (
    <div style={glassStyle({ padding: 14 })}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
          alignItems: "center",
        }}
      >
        <div>
          <h2 style={{ margin: 0, fontSize: 18 }}>Informe de envío</h2>
          <p style={{ margin: 0, opacity: 0.7, fontSize: 12 }}>
            Generados a partir de presupuestos aceptados.
          </p>
        </div>
        <button className="glass-btn" onClick={onNuevo}>
          + Nuevo informe
        </button>
      </div>

      {docs.length === 0 ? (
        <p style={{ fontSize: 13, opacity: 0.7 }}>
          Todavía no hay informes de envío.
        </p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              fontSize: 12,
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr style={{ opacity: 0.7 }}>
                <th style={{ padding: 6 }}>Número</th>
                <th style={{ padding: 6 }}>Fecha</th>
                <th style={{ padding: 6 }}>Cliente</th>
                <th style={{ padding: 6 }}>Presupuesto</th>
                <th style={{ padding: 6 }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((d) => (
                <tr key={d.id}>
                  <td style={{ padding: 6 }}>{d.numero}</td>
                  <td style={{ padding: 6 }}>{safeDate(d.fecha)}</td>
                  <td style={{ padding: 6 }}>{d.clienteNombre}</td>
                  <td style={{ padding: 6 }}>{d.presupuestoNumero}</td>
                  <td style={{ padding: 6 }}>
                    {d.pdfUrl && (
                      <a
                        href={`${API_BASE}${d.pdfUrl}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Ver PDF
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function SeccionInstalacion({ docs, onNuevo, onGestionChecklist }) {
  return (
    <div style={glassStyle({ padding: 14 })}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
          alignItems: "center",
        }}
      >
        <div>
          <h2 style={{ margin: 0, fontSize: 18 }}>Informe de instalación</h2>
        </div>

        <div style={{ display: "flex", gap: 6 }}>
          <button className="glass-btn" onClick={onGestionChecklist}>
            ⚙️ Checklist
          </button>
          <button className="glass-btn" onClick={onNuevo}>
            + Nuevo informe
          </button>
        </div>
      </div>

      {docs.length === 0 ? (
        <p style={{ fontSize: 13, opacity: 0.7 }}>
          Todavía no hay informes de instalación.
        </p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              fontSize: 12,
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr style={{ opacity: 0.7 }}>
                <th style={{ padding: 6 }}>Número</th>
                <th style={{ padding: 6 }}>Fecha</th>
                <th style={{ padding: 6 }}>Cliente</th>
                <th style={{ padding: 6 }}>Presupuesto</th>
                <th style={{ padding: 6 }}>Checks</th>
                <th style={{ padding: 6 }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((d) => (
                <tr key={d.id}>
                  <td style={{ padding: 6 }}>{d.numero}</td>
                  <td style={{ padding: 6 }}>{safeDate(d.fecha)}</td>
                  <td style={{ padding: 6 }}>{d.clienteNombre}</td>
                  <td style={{ padding: 6 }}>{d.presupuestoNumero}</td>
                  <td style={{ padding: 6 }}>
                    {(d.checklistTexto || []).join(", ")}
                  </td>
                  <td style={{ padding: 6 }}>
                    {d.pdfUrl && (
                      <a
                        href={`${API_BASE}${d.pdfUrl}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Ver PDF
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function SeccionBalance({
  clientes,
  balanceClienteId,
  setBalanceClienteId,
  balanceInfo,
  balanceLoading,
  balanceError,
  onBuscarBalance,
  onGenerarPdf,
}) {
  return (
    <div style={glassStyle({ padding: 14 })}>
      <h2 style={{ marginTop: 0, marginBottom: 10, fontSize: 18 }}>
        Balance de facturas
      </h2>

      <div style={{ marginBottom: 16 }}>
        <label>Cliente</label>
        <select
          className="glass-input"
          value={balanceClienteId}
          onChange={(e) => setBalanceClienteId(e.target.value)}
        >
          <option value="">Selecciona un cliente…</option>
          {clientes.map((c) => (
            <option key={c.id} value={c.id}>
              {c.nombre_empresa || c.nombre || `ID ${c.id}`}
            </option>
          ))}
        </select>

        <button
          className="glass-btn"
          style={{ marginLeft: 10 }}
          onClick={onBuscarBalance}
          disabled={!balanceClienteId}
        >
          Ver balance
        </button>
      </div>

      {balanceError && (
        <p style={{ color: "#f87171", fontSize: 13 }}>{balanceError}</p>
      )}

      {balanceLoading && <p>Cargando…</p>}

      {balanceInfo && (
        <>
          <h3 style={{ fontSize: 14, marginTop: 10 }}>
            Cliente:{" "}
            {balanceInfo.cliente.nombre_empresa ||
              balanceInfo.cliente.nombre ||
              `ID ${balanceInfo.cliente.id}`}
          </h3>

          <div style={{ overflowX: "auto", marginTop: 10 }}>
            <table
              style={{
                width: "100%",
                fontSize: 12,
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr style={{ opacity: 0.7 }}>
                  <th style={{ padding: 6 }}>Número</th>
                  <th style={{ padding: 6 }}>Fecha</th>
                  <th style={{ padding: 6 }}>Total</th>
                  <th style={{ padding: 6 }}>Pagado</th>
                  <th style={{ padding: 6 }}>Pendiente</th>
                  <th style={{ padding: 6 }}>Estado</th>
                </tr>
              </thead>
              <tbody>
                {balanceInfo.facturas.map((f) => (
                  <tr key={f.numero}>
                    <td style={{ padding: 6 }}>{f.numero}</td>
                    <td style={{ padding: 6 }}>{safeDate(f.fecha)}</td>
                    <td style={{ padding: 6 }}>{f.totalFmt}</td>
                    <td style={{ padding: 6 }}>{f.pagadoFmt}</td>
                    <td style={{ padding: 6 }}>{f.pendienteFmt}</td>
                    <td style={{ padding: 6 }}>{f.estadoPago}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button
            className="glass-btn"
            style={{ marginTop: 10 }}
            onClick={onGenerarPdf}
          >
            Generar PDF
          </button>
        </>
      )}
    </div>
  );
}

function Modal({ children, onClose, title }) {
  return (
    <div className="modal-overlay">
      <div
        className="modal-content"
        style={{ maxWidth: 700, width: "100%", ...glassStyle() }}
      >
        <div
          className="modal-header"
          style={{
            borderBottom: "1px solid rgba(255,255,255,0.15)",
            marginBottom: 10,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: 6,
          }}
        >
          <h2 style={{ margin: 0, fontSize: 18 }}>{title}</h2>
          <button className="btn-small" onClick={onClose}>
            ✕
          </button>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}

